import { useQuery } from "@apollo/client";
import { USER_ME } from "../../graphql/queries/UserQueries";
import LogRocket from "logrocket";

export const useUser = () => {
  const { data, ...rest } = useQuery(USER_ME);

  if (data?.userMe) {
    LogRocket.identify(data.userMe.id, {
      name: `${data.userMe.firstName} ${data.userMe.lastName}`,
      email: data.userMe.email,
    });
  }

  return {
    user: data?.userMe,
    ...rest,
  };
};
